/**
 * Persistência do claim pendente do convidado (entre a tela pós-donate e o signup → login).
 * Guarda `{ donationId, claimToken }` em localStorage para sobreviver ao redirect de cadastro.
 * Resiliente a localStorage indisponível (modo privado/SSR).
 */
const STORAGE_KEY = "rino:gamification:pending-claim";

export interface PendingClaim {
  donationId: string;
  claimToken: string;
}

export function savePendingClaim(claim: PendingClaim): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(claim));
  } catch {
    // localStorage indisponível — segue sem persistir.
  }
}

export function readPendingClaim(): PendingClaim | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<PendingClaim>;
    if (parsed && typeof parsed.donationId === "string" && typeof parsed.claimToken === "string") {
      return { donationId: parsed.donationId, claimToken: parsed.claimToken };
    }
    return null;
  } catch {
    return null;
  }
}

export function clearPendingClaim(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
